export default __webpack_public_path__ + "static/media/TLC Photo.f6234d5e.png";